import { ButtonArrowStyled, UPButtonStyled } from './styles';
import './styles.scss';
import { UPButtonProps } from './types';

const UPButton = (props: UPButtonProps): JSX.Element => {
  const { text, onClick, disabled, outlined, className, ref, withArrow, gtmEvent, id, testId } = props;

  return (
    <UPButtonStyled
      variant={outlined ? 'outlined' : 'contained'}
      endIcon={withArrow && <ButtonArrowStyled />}
      onClick={onClick}
      disabled={disabled}
      className={className}
      ref={ref}
      data-gtm-event={gtmEvent}
      data-testid={testId}
      id={id}
    >
      {text}
    </UPButtonStyled>
  );
};

UPButton.defaultProps = {
  disabled: false,
  outlined: false,
  className: '',
  value: '',
};

export default UPButton;
